import signature1 from "../assets/images/signature_11.png";
// TODO: rename to signature_drsujay.png once the real PNG is in place
import signature2 from "../assets/images/signature_drpramod.png";

export const NONE_DOCTOR_ID = "none";

export const DOCTORS = [
  {
    id: "prajjal",
    name: "Dr. Prajjal Kumar Sinha",
    qualifications: "MBBS, MD(GM), DM (Interventional Cardiology)",
    regLabel: "Reg Number: 69828",
    signature: signature1,
  },
  {
    id: "sujay",
    name: "Dr. Sujay Renga",
    qualifications: "MD, DM, FACC, FESC, FSCAI — Senior Interventional Cardiologist",
    regLabel: "Reg Number: TCMC29035",
    signature: signature2,
  },
];

export const DEFAULT_DOCTOR_ID = NONE_DOCTOR_ID;

// Fixed default doctor used to sign the ARCHIVED copy when an unsigned report
// is published. Not user-selectable — see HandlePublish in Report.jsx.
export const SIGNED_COPY_DOCTOR_ID = "prajjal";

export const getDoctorById = (id) =>
  DOCTORS.find((d) => d.id === id) || null;
